import {
    call,
    put,
    take,
    select
} from 'redux-saga/effects';

import {
    CHECK_GIFT_CARD_BALANCE,
    updateGiftCardBalance,
    giftCardError,
    SUBMIT_CONTACT_US_FORM,
    contactUsFormSuccess,
    contactUsFormError,
    EMAIL_UNSUBSCRIBE,
    emailUnsubscribeError,
    emailUnsubscribeSuccess,
    signUpForEmailSuccess,
    signUpForEmailError,
    SAVE_EMAIL_SIGN_UP_DATA,
    changeAppointmentType,
    setStoresForPersonalShopper,
    setStylistEmailAddress
} from '../actions/helpActions';

import {
    getStoresForRegion,
    getDefaultStylistEmailAddress
} from '../components/stylistPreferredLocationComponent.js';

import {
    makeRequest
} from '../../../core/js/sagas/makeRequest';

import {
    MISL_BRANDS
} from '../../../core/js/enums/mislEnums';

import { error } from '../../../core/js/utils/logger';
import apiRoutes from '../../../core/js/utils/apiRoutes';

import {
    SUBSCRIPTION_ACTIONS,
    SOURCES
 } from '../../../core/js/constants';

import { getCurrencyFormattingInfo } from '../../../core/js/utils/contentfulUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';
import {
    createGenericUnknownError,
    buildErrorsFromResponse
} from '../../../core/js/utils/errorHandling';

export function *getBalance() {
    let state = yield select();
    const route = apiRoutes.getGiftCardBalance(state);

    return yield call(makeRequest, route);
}

export function *giftCardBalanceSaga() {
    let payload = {};

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(CHECK_GIFT_CARD_BALANCE)) {
        const state = yield select();

        try {
            const response = yield call(getBalance);
            const giftCardCurrencyFormattingInfo = getCurrencyFormattingInfo(state, response.currencyCode);

            yield put(updateGiftCardBalance(response.amount, giftCardCurrencyFormattingInfo));
        } catch (error) {
            yield put(giftCardError(error));
        }
    }
}

export function *submitContactUsFormSaga() {
    let payload = '';

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(SUBMIT_CONTACT_US_FORM)) {
        try {
            let state = yield select();

            const params = {
                subjectCode: payload.data.subjectCode.toString(),
                name: {
                    middle: '',
                    prefix: '',
                    last: payload.data.lastName,
                    suffix: '',
                    first: payload.data.firstName
                },
                sessionData: '',
                orderNumber: payload.data.orderNumber,
                messageBody: payload.data.contactMessage,
                replyToEmail: payload.data.emailAddress,
                subjectText: payload.data.topic
            };

            const route = apiRoutes.getContactUsRoute(state, params);
            const contactUsResponse = yield call(makeRequest, route);

            yield put(contactUsFormSuccess(contactUsResponse));
        } catch (err) {
            yield put(contactUsFormError('CONTACTUS_SUBMIT_ERROR'));
            error('Error submitting Contact Us Form', err);
        }
    }
}

export function *getStoresForPersonalShopper() {
    try {
        let state = yield select();
        const route = apiRoutes.getStoresForPersonalShopper(state);
        const storesForPersonalShopper = yield call(makeRequest, route);

        return storesForPersonalShopper;
    } catch (err) {
        error('Error encountered while getting stores for personal shopper', err);
    }
}

export function *updateShopperAppointmentType(appointmentTypeData) {
    try {
        yield put(changeAppointmentType(appointmentTypeData));

        let state = yield select();
        const response = yield call(getStoresForPersonalShopper);

        const storesForUSRegion = getStoresForRegion(state, response.results, MISL_BRANDS['an-us']);
        const storesForUKRegion = getStoresForRegion(state, response.results, MISL_BRANDS['an-uk']);
        const storesForPersonalShopperList = $.extend(storesForUSRegion, storesForUKRegion);

        yield put(setStoresForPersonalShopper(storesForPersonalShopperList));
        yield put(setStylistEmailAddress(getDefaultStylistEmailAddress(storesForPersonalShopperList)));
    } catch (err) {
        error('Error updating appointment type', err);
    }
}

export function *requestCatalogSaga(formData) {
    const state = yield select();

    try {
        const route = apiRoutes.submitCatalogRequest(state, formData);

        yield call(makeRequest, route);
    } catch (err) {
        error('Error requesting catalog', err);
    }
}

export function *submitEmailUnsubscribeSaga() {
    let payload = {};

    const action = SUBSCRIPTION_ACTIONS.UNSUBSCRIBE;

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(EMAIL_UNSUBSCRIBE)) {
        let state = yield select();
        let source = _.get(state, 'core.featureConfigs.helpAnonymousEmailSubscriptions.source', SOURCES.HELP);

        try {
            const route = apiRoutes.unsubscribeToEmailSubscription(state, source, action, payload.email);
            const res = yield call(makeRequest, route);

            yield put(emailUnsubscribeSuccess(res));
        } catch (err) {
            payload.response = {
                entity: err.entity,
                status: err.status
            };
            yield put(emailUnsubscribeError(payload.response));
            error('Error unsubscribing email', err);
        }
    }
}

export function *signUpForEmail() {
    let payload = {};

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(SAVE_EMAIL_SIGN_UP_DATA)) {
        try {
            // eslint-disable-next-line no-cond-assign
            let state = yield select();
            const emailAddress = payload.formData.emailAddress;
            const gender = payload.formData.gender;
            const subscriptionSource = payload.formData.source;
            const utagData = {
                event_name: 'email_signup',
                customer_email: emailAddress
            };
            const route = apiRoutes.createAnonymousEmailSubscription(state, subscriptionSource, emailAddress, gender);

            yield call(makeRequest, route);
            yield put(signUpForEmailSuccess(payload.formData));
            yield put(handleUtagEvent(utagData, 'link'));
        } catch (err) {
            payload.response = {
                entity: err.entity,
                status: err.status
            };
            error('Error encountered while creating anonymous email subscription', err);

            yield put(signUpForEmailError(payload.response));
        }
    }
}

export default [
    giftCardBalanceSaga,
    submitContactUsFormSaga,
    submitEmailUnsubscribeSaga,
    signUpForEmail
];
